import { useMemo } from 'react';
import { Cards as CardsPortal } from '@uaveiro/ui';
import { withPortalProviders } from 'modules/utils';

const Cards = (props) => {
  const computedProps = useMemo(() => {
    // do the convertion logic here
    const { data, ...cardsProps } = props
    const newProps = { ...cardsProps, content: data, activeColor: '#000' }
    return newProps
  }, [props])
  return withPortalProviders(CardsPortal, computedProps);
};
export default Cards;
